import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import 'components/site/commons/dashboardWrapper.scss';
import TopNav from 'components/site/commons/TopNav';

export default (ChildComponent) => (props) => (
  <div id="mjlApp">
    <nav className="nav-right">
      <div
        className="nav-brand d-flex"
        style={{ justifyContent: 'space-between' }}
      >
        <div className="img-wrap">
          <Link to="/">
            <img src="/assets/images/logo.svg" alt="logo" />
          </Link>
        </div>
        <Link
          to="/places"
          className="btn btn-default btn-sm"
          style={{ padding: '10px 35px', backgroundColor: 'transparent' }}
        >
          Exit
        </Link>
      </div>
      <ul className="nav-links neutralize">
        <RenderLink isEdit={props.isEdit} id={props.match.params.id} />
      </ul>
    </nav>
    <div className="_main_panel">
      <TopNav />
      <div className="_bod_wrap">
        <div className="_bod_content">
          <ChildComponent {...props} />
        </div>
      </div>
    </div>
  </div>
);

function RenderLink({ isEdit, id }) {
  if (isEdit) {
    return (
      <>
        <li>
          <NavLink to={`/places/edit/${id}`} exact={true}>
            <div className="s-icon">
              <i className="fas fa-circle"></i>
            </div>
            Basic Information
          </NavLink>
        </li>
        <li>
          <NavLink to={`/places/edit/${id}/image`}>
            <div className="s-icon">
              <i className="fas fa-circle"></i>
            </div>
            Photo
          </NavLink>
        </li>
      </>
    );
  } else {
    return (
      <>
        <li>
          <NavLink to="/places/new">
            <div className="s-icon">
              <i className="fas fa-circle"></i>
            </div>
            Basic Information
          </NavLink>
        </li>
        <li>
          <button>
            <div className="s-icon">
              <i className="fas fa-lock text-muted"></i>
            </div>
            Photo
          </button>
        </li>
      </>
    );
  }
}
